export default {
  primary: "#132339",
  secondary: "#134074",
  tertiary: "#8da9c4",
  accent: "#eef4ed",
  error: "#f55a4e",
  info: "#00d3ee",
  success: "#5cb860",
  warning: "#ffa21a",
  general: "#2196F3"
};
